import React, { useEffect } from 'react'

import {
  Input,
  Picker,
  Row,
  Select,
  Span,
  Form,
  Button,
  Grid,
  Text
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import moment from 'moment'
import { useFormContext } from 'react-hook-form'
import { LogEmailJobService } from 'services/GST/Parameterization'
import { SPACING, FUNCTIONS, COLORS } from 'utils'

import { IForm } from '../types'

export interface IFilterJobsProps {
  refreshTable: (_props: any) => void
  handleSubmitForm: (_props: IForm) => void
  setTipos: React.Dispatch<React.SetStateAction<any[]>>
  tipos: any[]
}

const FiltersJobs: React.FC<IFilterJobsProps> = ({
  handleSubmitForm,
  tipos,
  refreshTable,
  setTipos
}) => {
  const {
    control,
    watch,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useFormContext<IForm>()

  const selectValue = watch('NmTipoJOB')
  const dtInicio = watch('DtEnvioInicio')
  const dtFim = watch('DtEnvioFim')

  const getTipos = () => {
    LogEmailJobService()
      .getTipos()
      .then(({ data }) => {
        setTipos(data)
      })
  }

  const handleResetForm = () => {
    reset()
    const formatedObj: IForm = {
      txTipoContexto: 'GST',
      pageNumber: 1,
      pageSize: 15
    }

    refreshTable({ ...FUNCTIONS.filterObject(formatedObj, Boolean) })
  }

  useEffect(() => {
    getTipos()
  }, [])

  return (
    <Form
      onSubmit={handleSubmit(handleSubmitForm)}
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <Row alignItems="center" justifyContent="start">
        <Input
          defaultValue={''}
          label="Contrato"
          marginRight={SPACING.spacing15}
          placeholder="Número Contrato"
          formValue="CdContrato"
          control={control}
        />
        <Input
          defaultValue={''}
          label="Fornecedor"
          marginRight={SPACING.spacing15}
          placeholder="Nome Fornecedor"
          formValue="NmFornecedor"
          control={control}
        />
        <Picker
          maxDate={moment(dtFim).toISOString()}
          defaultValue={null}
          label="Data de Envio"
          marginRight={SPACING.spacing15}
          control={control}
          formValue="DtEnvioInicio"
        />
        <Span text="à" marginRight={SPACING.spacing15} style={{ alignItems: "end", display: "flex" }} />
        <Picker
          minDate={moment(dtInicio).toISOString()}
          formValue="DtEnvioFim"
          control={control}
          defaultValue={null}
        />
      </Row>
      <Row
        alignItems="center"
        justifyContent="start"
        marginTop={SPACING.spacing20}
        marginBottom={SPACING.spacing15}
      >
        <Grid
          gridCols="3fr 3fr 16fr 3fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`0 0 ${SPACING.spacing30} 0`}
        >
          <Input
            defaultValue={''}
            formValue="NmContraparte"
            control={control}
            label="Contraparte"
            placeholder="Nome do Contraparte"
          />
          <Select
            defaultValue={null}
            onChange={(e) => {
              setValue('NmTipoJOB', e.target.value)
            }}
            value={selectValue}
            clearSelect={true}
            valueMenu=""
            labelMenu=""
            listOptions={tipos}
            errors={errors}
            label="Tipo"
            formValue="NmTipoJOB"
          />

          <Row justifyContent="flex-end">
            <Button
              variantButton="text"
              text="LIMPAR"
              width={'max-content'}
              onClick={handleResetForm}
              marginRight={SPACING.spacing20}
            />
            <Button
              endIcon={<MagnifyingGlassIcon />}
              type="submit"
              text="Pesquisar"
            />
          </Row>

        </Grid>
      </Row>
    </Form>
  )
}

export default FiltersJobs